import { Fragment } from "react";
import { WarrantyClaimsTables } from "./WarrantyClaimTable";
const WarrantyClaims = () => {
  return (
    <Fragment>
      <WarrantyClaimsTables />
    </Fragment>
  );
};

export default WarrantyClaims;
